export const defaultAvailability = {
  title: "Default Availability",
  timezone: "UTC",
  days: [
    {
      day: "sunday",
      time: [],
    },
    {
      day: "monday",
      time: [{ start_time: "09:00:00", end_time: "17:00:00" }],
    },
    {
      day: "tuesday",
      time: [{ start_time: "09:00:00", end_time: "17:00:00" }],
    },
    {
      day: "wednesday",
      time: [{ start_time: "09:00:00", end_time: "17:00:00" }],
    },
    {
      day: "thursday",
      time: [{ start_time: "09:00:00", end_time: "17:00:00" }],
    },
    {
      day: "friday",
      time: [{ start_time: "09:00:00", end_time: "17:00:00" }],
    },
    {
      day: "saturday",
      time: [],
    },
  ],
};
